import { CurrencyEnum, DEFAULT_CURRENCY } from '../common/currency'
import { LocaleEnum } from '../types/i18n'

const localeToIntlMap: Record<LocaleEnum, string> = {
  [LocaleEnum.en]: 'en-US',
  [LocaleEnum.fr]: 'fr-FR',
  [LocaleEnum.de]: 'de-DE',
  [LocaleEnum.es]: 'es-ES',
  [LocaleEnum.pt]: 'pt-BR',
  [LocaleEnum.it]: 'it-IT',
  [LocaleEnum.pl]: 'pl-PL',
  [LocaleEnum.tr]: 'tr-TR',
  [LocaleEnum.sv]: 'sv-SE',
}

interface FormatCurrencyParams {
  amount: number
  currency?: CurrencyEnum
  locale?: LocaleEnum
}

export function formatCurrency({ amount, currency, locale }: FormatCurrencyParams): string {
  const intlLocale = localeToIntlMap[locale ?? LocaleEnum.en] ?? 'en-US'
  const currencyCode = (currency ?? DEFAULT_CURRENCY).toUpperCase()
  return new Intl.NumberFormat(intlLocale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
